import { render, staticRenderFns } from "./details-setting.vue?vue&type=template&id=d27bf036&scoped=true&"
import script from "./details-setting.vue?vue&type=script&lang=js&"
export * from "./details-setting.vue?vue&type=script&lang=js&"
import style0 from "./details-setting.vue?vue&type=style&index=0&id=d27bf036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27bf036",
  null
  
)

export default component.exports